var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-button',{attrs:{"type":"primary"},on:{"click":_vm.download}},[_c('i',{staticClass:"far fa-file"}),_vm._v(" "+_vm._s(_vm.$t('report.download_csv_report')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }